import { useEffect } from 'react'

/**
 * Fixes a timing issue where React Aria marks Stripe Link's iframe container
 * as `inert` despite it having the `data-react-aria-top-layer` attribute.
 * @param isActive Whether to actively observe for the issue (typically tied to modal visibility).
 */
export function useStripeLinkAriaFix(isActive: boolean) {
  useEffect(() => {
    if (!isActive) {
      return
    }

    const observer = new MutationObserver(() => {
      document
        .querySelector(
          '[data-react-aria-top-layer][inert]:has(iframe[name^="__privateStripeFrame"][src*="universal-link-modal"])',
        )
        ?.removeAttribute('inert')
    })

    observer.observe(document.body, {
      attributeFilter: ['inert'],
      childList: true,
      subtree: true,
    })

    return () => {
      observer.disconnect()
    }
  }, [isActive])
}
